import { useEffect, useMemo, useState } from "react";
import { FolderSimple } from "@phosphor-icons/react";
import api from "@/lib/api";

// Flatten nested tree into [{node, depth}, …] for non-recursive rendering.
function flattenTree(folders) {
  const map = {};
  folders.forEach((f) => { map[f.id] = { ...f, children: [] }; });
  const roots = [];
  folders.forEach((f) => {
    if (f.parent_folder_id && map[f.parent_folder_id]) map[f.parent_folder_id].children.push(map[f.id]);
    else roots.push(map[f.id]);
  });
  const out = [];
  const stack = roots.map((r) => ({ node: r, depth: 0 })).reverse();
  while (stack.length) {
    const cur = stack.pop();
    out.push(cur);
    for (let i = cur.node.children.length - 1; i >= 0; i--) {
      stack.push({ node: cur.node.children[i], depth: cur.depth + 1 });
    }
  }
  return out;
}

export function MovePicker({ teamId, onPick }) {
  const [folders, setFolders] = useState([]);
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/teams/${teamId}/folder-tree`).then(({ data }) => setFolders(data.items || [])).finally(() => setLoading(false));
  }, [teamId]);

  const flat = useMemo(() => flattenTree(folders), [folders]);

  return (
    <div className="space-y-3" data-testid="move-picker">
      <div className="text-sm text-black/65">Pick a destination folder.</div>
      <div className="border border-black/10 rounded-md max-h-72 overflow-y-auto">
        <button onClick={() => setTarget(null)} data-testid="move-target-root"
                className={`w-full px-3 py-2 text-left text-sm border-b border-black/5 ${target === null ? "bg-[#FF3366]/5 font-medium" : "hover:bg-black/5"}`}>
          Drive (root)
        </button>
        {loading
          ? <div className="p-3 text-sm text-black/55">Loading…</div>
          : flat.length === 0
            ? <div className="p-3 text-sm text-black/55">No folders yet.</div>
            : flat.map(({ node, depth }) => (
                <button key={node.id} onClick={() => setTarget(node.id)} data-testid={`move-target-${node.id}`}
                        className={`w-full px-3 py-2 text-left flex items-center gap-2 text-sm border-b border-black/5 ${target === node.id ? "bg-[#FF3366]/5 font-medium" : "hover:bg-black/5"}`}
                        style={{ paddingLeft: 12 + depth * 18 }}>
                  <FolderSimple size={14} weight="fill" className="text-[#FFA000]"/> {node.name}
                </button>
              ))}
      </div>
      <button onClick={() => onPick(target)} className="w-full bg-black text-white py-2.5 rounded-md" data-testid="move-confirm">Move here</button>
    </div>
  );
}
